import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import { AlertInfo, AlertType, AlertRecord, AlertCategories, AlertLevel } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";
import { generateMockAlertBase } from "../mocking-utils";
import { pleaseCallPoolsideSupportContact } from "../../utils/common-text";


export class DiskSpaceLow extends AlertLogic {
    static type = AlertType.DiskSpaceLow;
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.SYSTEM_ERROR ];
    static title = Locale.gettext('Low Storage');

    getInfo(alert: AlertRecord = this.alert, config: Config.AllConfig = this.allConfigs): AlertInfo {
        const { alertData } = this.getCommons(alert, config);

        const controllerConfig = config.Config?.Controllers?.find(item => item.UUID === alert.entityUuid)
            || { Name: alert.entityUuid }
        ;

        const conditionText = Locale.gettext("Your Attendant is experiencing a low disk storage condition.");
        const actionText = pleaseCallPoolsideSupportContact;

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: DiskSpaceLow.title,
            cardDescription: conditionText,
            cardIllustration: "pipes_emergency",
            
            detailIcon: "harddisk",
            detailDescriptionArr: [
                conditionText,
                /*
                Locale.gettext("Available space on %s: %s (%s).",
                    controllerConfig.Name,
                    Locale.formatPercentage(alertData.FreePercent, 0),
                    alertData.MountPoint
                ),
                */
                actionText,
            ]
        });
            
        alertInfo.contentCategories = DiskSpaceLow.contentCategories;

        return alertInfo;
    } 

    static mock(type: AlertType, config: Config.AllConfig): AlertRecord {
        const controllerUuid = config.Config?.Controllers?.[ 0 ].UUID;
        if (!controllerUuid) throw new Error(`Create a Controller to mock ${type} alert.`);

        const alertRecord = generateMockAlertBase(type, controllerUuid);
        Object.assign(
            alertRecord,
            {
                data: {
                    MountPoint: "/",
                    TotalKB: 1934200,
                    UsedKB: 1785324,
                    AvailableKB: 148876,
                    FreePercent: 7.697032364801985,
                    ThresholdPercent: 10
                },
                entityUuid: controllerUuid,
                level: AlertLevel.Error,
            }
        );

        /* Full example
        {
            "id": 472575,
            "uuid": "d93eed39-77cc-422e-b215-05d9998d1911",
            "siteId": 457,
            "deviceId": 634,
            "entityUuid": "939efa0e-0215-4e09-a8fe-6e00152b898d",
            "bodyUuid": null,
            "type": "DISK_SPACE_LOW",
            "level": "ERROR",
            "data": {
                "MountPoint": "/",
                "TotalKB": 1934200,
                "UsedKB": 1785324,
                "AvailableKB": 148876,
                "FreePercent": 7.697032364801985,
                "ThresholdPercent": 10
            },
            "state": "OPEN",
            "closedBy": null,
            "created": "2025-12-17T22:03:20.000Z",
            "updated": "2025-12-17T22:06:38.000Z",
            "site": {
                "shared": false,
                "online": null,
                "id": 457,
                "userId": 14,
                "uuid": "ab42c8d3-81dc-4f2f-9ea5-b110ca679ee5",
                "name": "ABluetooth",
                "country": "United States",
                "state": "Illinois",
                "city": "Riverwoods",
                "address": "1005 Oakhurst Ln",
                "zip": "60015",
                "latitude": "42.17105967093800",
                "longitude": "-87.87803542235800",
                "manualFiltering": true,
                "maintainerId": null,
                "maintainerLocationUuid": null,
                "exportForAssistants": false,
                "created": "2024-05-31T19:36:31.000Z",
                "lastSeen": "2025-12-19T16:11:30.000Z",
                "deleted": 0,
                "monitored": false,
                "version": "7f9052096c00c27a41c08b4f29ca22a752d86c15",
                "versionName": "2.3.1",
                "timezone": "America/Chicago",
                "trainingVisit": null,
                "trainingTech": null,
                "vip": false,
                "noAutoUpdate": false
            },
            "device": {
                "online": null,
                "vpnHandler": null,
                "id": 634,
                "userId": null,
                "siteId": 457,
                "deviceNumber": 1,
                "uuid": "939efa0e-0215-4e09-a8fe-6e00152b898d",
                "model": "Attendant",
                "serial": "aaaaaaaaaaaaa",
                "vpnPublicKey": "EUpJbH1zHS9tSGckiOfYYAoC83ZPRBU6VTjtMybRIjE=",
                "vpnAddress": "10.0.1.121/32",
                "created": "2024-12-24T21:35:44.000Z",
                "lastSeen": "2025-12-19T16:13:02.000Z",
                "lastIp": "24.13.58.197",
                "version": "7f9052096c00c27a41c08b4f29ca22a752d86c15",
                "versionName": "2.3.1",
                "sku": null,
                "qaDate": null,
                "qaBatch": null,
                "qaUser": null,
                "shippingDate": null,
                "shippingTo": null,
                "shippingId": null,
                "distributorLocationUuid": null,
                "distributorPo": null,
                "poolsideInvoiceNumber": null,
                "poolsideInvoiceDate": null,
                "tryMe": false,
                "demoUnit": false
            }
        }
        */

        return alertRecord;
    }
}
